import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const STR = {
  de: {
    "nav.course": "Kurs", "nav.dashboard": "Dashboard", "nav.search": "Suche",
    "nav.bookmarks": "Gespeichert", "nav.profile": "Profil", "nav.login": "Anmelden",
    "nav.logout": "Abmelden", "nav.start": "Kostenlos starten",
    "hero.title1": "KI verstehen.", "hero.title2": "KI beherrschen.", "hero.title3": "KI nutzen.",
    "hero.sub": "Die premium Akademie, die dich von den Grundlagen zur professionellen KI-Nutzung führt — für Arbeit, Business und Kreativität.",
    "hero.cta": "Kostenlos starten", "hero.cta2": "Kurs entdecken",
    "landing.learn.title": "Was du lernst",
    "landing.learn.sub": "Ein strukturierter Weg vom ersten Prompt bis zum professionellen Workflow.",
    "landing.path.title": "Dein Lernweg",
    "landing.categories.title": "12 Module, ~75 Lektionen",
    "landing.why.title": "Warum KI jetzt zählt",
    "landing.why.body": "KI ist keine ferne Zukunft mehr — sie verändert heute, wie wir arbeiten, schreiben, recherchieren und entscheiden. Wer sie beherrscht, gewinnt Zeit und Klarheit.",
    "landing.apps.title": "Praktische Anwendungen",
    "landing.progress.title": "Dein Fortschritt, gespeichert",
    "landing.progress.body": "Jede abgeschlossene Lektion wird gespeichert. Du machst genau dort weiter, wo du aufgehört hast — auf jedem Gerät.",
    "landing.benefits.title": "Was dich erwartet",
    "landing.faq.title": "Häufige Fragen",
    "landing.finalcta.title": "Beginne heute deinen KI-Weg",
    "landing.finalcta.sub": "Kostenlos. Kein Risiko. In drei Sprachen.",
    "benefit.1t": "Echtes Können", "benefit.1b": "Keine Theorie ohne Nutzen — jede Lektion ist sofort anwendbar.",
    "benefit.2t": "Dreisprachig", "benefit.2b": "Vollständig in Deutsch, Rumänisch und Englisch.",
    "benefit.3t": "In deinem Tempo", "benefit.3b": "Fortschritt gespeichert, offline lesbar, jederzeit weiter.",
    "benefit.4t": "Für Profis gemacht", "benefit.4b": "Editorial, klar und respektvoll — kein Gamification-Kitsch.",
    "auth.login.title": "Willkommen zurück", "auth.register.title": "Konto erstellen",
    "auth.email": "E-Mail", "auth.password": "Passwort", "auth.name": "Name",
    "auth.login.btn": "Anmelden", "auth.register.btn": "Kostenlos registrieren",
    "auth.google": "Mit Google fortfahren", "auth.or": "oder",
    "auth.forgot": "Passwort vergessen?",
    "auth.noaccount": "Noch kein Konto?", "auth.hasaccount": "Bereits registriert?",
    "auth.toRegister": "Jetzt registrieren", "auth.toLogin": "Anmelden",
    "forgot.title": "Passwort zurücksetzen", "forgot.sub": "Wir senden dir einen Link per E-Mail.",
    "forgot.btn": "Link senden", "forgot.sent": "Falls die E-Mail existiert, wurde ein Link gesendet.",
    "reset.title": "Neues Passwort", "reset.btn": "Passwort speichern", "reset.done": "Passwort geändert. Du kannst dich jetzt anmelden.",
    "onboard.skip": "Überspringen", "onboard.next": "Weiter", "onboard.start": "Los geht's",
    "onboard.1t": "Willkommen bei AI Lernwerk", "onboard.1b": "Eine ruhige, fokussierte Akademie für echte KI-Kompetenz.",
    "onboard.2t": "Strukturiert lernen", "onboard.2b": "12 Module führen dich Schritt für Schritt vom Anfänger zum Power-User.",
    "onboard.3t": "Sofort anwendbar", "onboard.3b": "Kopierbare Prompts, echte Beispiele und Übungen in jeder Lektion.",
    "onboard.4t": "Dein Fortschritt zählt", "onboard.4b": "Alles wird gespeichert. Mach weiter, wo du aufgehört hast.",
    "dash.welcome": "Willkommen zurück", "dash.progress": "Gesamtfortschritt",
    "dash.continue": "Weiterlernen", "dash.current": "Aktuelles Modul", "dash.next": "Empfohlene nächste Lektion",
    "dash.modules": "Alle Module", "dash.daily": "Lektion des Tages", "dash.lessons": "Lektionen", "dash.done": "abgeschlossen",
    "dash.start": "Ersten Kurs beginnen", "dash.nolast": "Beginne mit deiner ersten Lektion.",
    "course.title": "Der Kurs", "course.sub": "12 Module · ~75 Lektionen",
    "lesson.complete": "Als abgeschlossen markieren", "lesson.completed": "Abgeschlossen",
    "lesson.prev": "Zurück", "lesson.next": "Nächste", "lesson.examples": "Beispiele",
    "lesson.exercise": "Übung", "lesson.mistakes": "Häufige Fehler", "lesson.takeaway": "Kernaussage",
    "lesson.copy": "Prompt kopieren", "lesson.copied": "Kopiert!", "lesson.bookmark": "Speichern",
    "lesson.bookmarked": "Gespeichert", "lesson.generating": "Inhalt wird generiert…",
    "search.title": "Suche", "search.placeholder": "Lektionen & Themen suchen…", "search.none": "Keine Ergebnisse.",
    "bookmarks.title": "Gespeicherte Lektionen", "bookmarks.none": "Noch nichts gespeichert.",
    "profile.title": "Dein Profil", "profile.account": "Konto", "profile.language": "Sprache",
    "profile.security": "Sicherheit", "profile.changepw": "Passwort ändern",
    "profile.current": "Aktuelles Passwort", "profile.new": "Neues Passwort", "profile.save": "Speichern",
    "profile.danger": "Konto löschen", "profile.deletebtn": "Konto endgültig löschen",
    "profile.deleteconfirm": "Konto wirklich löschen? Es wird in 30 Tagen endgültig entfernt (Soft-Delete).",
    "profile.saved": "Gespeichert.", "profile.stats": "Deine Statistik",
    "common.loading": "Lädt…", "common.cancel": "Abbrechen", "common.of": "von",
    "footer.legal": "Rechtliches", "footer.imprint": "Impressum", "footer.privacy": "Datenschutz",
    "footer.terms": "AGB", "footer.rights": "Alle Rechte vorbehalten.",
    "cookie.text": "Wir nutzen Cookies für Login und (später) Analyse. Details im Datenschutz.",
    "cookie.accept": "Akzeptieren", "cookie.decline": "Nur notwendige",
    "nav.notes": "Notizen",
    "notes.heading": "Deine Notiz", "notes.placeholder": "Notiz zu dieser Lektion…",
    "notes.save": "Notiz speichern", "notes.saved": "Notiz gespeichert",
    "notes.title": "Deine Notizen", "notes.none": "Noch keine Notizen.",
    "cert.title": "Zertifikat", "dash.certificate": "Zertifikat ansehen",
    "cert.locked": "Schließe alle Lektionen ab, um dein Zertifikat freizuschalten.",
    "cert.remaining": "verbleibend", "cert.download": "Zertifikat herunterladen",
    "cert.awarded": "verliehen an", "cert.subtitle": "hat die AI-Lernwerk-Akademie erfolgreich abgeschlossen",
    "cert.congrats": "Herzlichen Glückwunsch!", "cert.line": "für den erfolgreichen Abschluss von 12 Modulen und 75 Lektionen",
    "cert.download_pdf": "Als PDF herunterladen",
    "cert.finished_title": "Programm abgeschlossen",
    "cert.finished_sub": "Du hast alle 12 Module und 75 Lektionen abgeschlossen.",
    "cert.free_note": "Der gesamte Kurs ist und bleibt 100 % kostenlos. Das Zertifikat ist optional.",
    "cert.buy_line": "Das digitale Abschlusszertifikat bestätigt, dass du das Programm „AI Lernwerk – AI From Zero to Pro“ abgeschlossen hast. Einmalige Zahlung, kein Abo.",
    "cert.buy_btn": "Zertifikat erhalten – 10 €",
    "cert.buying": "Weiterleitung zu Stripe…",
    "cert.verifying": "Zahlung wird überprüft…",
    "cert.paid_ok": "Zahlung bestätigt – dein Zertifikat ist freigeschaltet.",
    "cert.canceled": "Zahlung abgebrochen. Dein Fortschritt bleibt erhalten – du kannst es erneut versuchen.",
    "cert.not_accredited": "Bestätigt den Abschluss des Programms. Keine staatliche oder akkreditierte Qualifikation.",
    "cert.name_label": "Vollständiger Name auf dem Zertifikat",
    "cert.name_ph": "z. B. Maria Musterfrau",
    "cert.name_required": "Bitte gib deinen vollständigen Namen ein.",
    "pwa.install": "PWA installieren",
    "pwa.howto": "So installierst du die App: Tippe in deinem Browser auf das Menü (bzw. „Teilen“ auf dem iPhone) und wähle „Zum Startbildschirm hinzufügen“.",
    "pwa.howto_ios": "So installierst du die App auf iPhone/iPad: Tippe unten in Safari auf „Teilen“ und dann auf „Zum Home-Bildschirm“.",
    "pwa.howto_android": "So installierst du die App: Öffne das Chrome-Menü (drei Punkte ⋮ oben rechts) und tippe auf „App installieren“ bzw. „Zum Startbildschirm hinzufügen“.",
    "pwa.close": "Verstanden",
    "ad.label": "Anzeige",
    "nav.admin": "Admin",
    "admin.eyebrow": "Nur für Admin", "admin.title": "Übersicht",
    "admin.error": "Daten konnten nicht geladen werden.",
    "admin.users": "Nutzer", "admin.revenue": "Zertifikat-Umsatz", "admin.certificates": "Zertifikate verkauft",
    "admin.pwa": "PWA-Installationen", "admin.pwa_sub": "auf Geräten hinzugefügt",
    "admin.completed": "Kurs abgeschlossen", "admin.in_progress": "in Bearbeitung",
    "admin.traffic": "Traffic (30 Tage)", "admin.visits": "Besuche", "admin.registrations": "Registrierungen",
    "admin.traffic_note": "Besuche werden 1× pro Browser-Sitzung gezählt. Für rohen Traffic siehe PostHog.",
    "admin.modules": "Fortschritt pro Modul", "admin.started": "begonnen", "admin.done": "abgeschlossen",
    "admin.traffic_sources": "Traffic-Quellen", "admin.total_visitors": "Besucher gesamt",
    "admin.registered_users": "Registrierte Nutzer", "admin.source": "Quelle", "admin.campaign": "Kampagne",
    "admin.unknown_existing": "Unbekannt / Bestandsnutzer",
    "curr.eyebrow": "Lehrplan", "curr.title": "Der komplette KI-Lehrplan",
    "curr.sub": "12 Module, 75 Lektionen — kostenlos lesbar. Von den Grundlagen bis zum Power-User.",
    "curr.read": "Lektion lesen", "curr.cta": "Kostenlos anmelden & Fortschritt speichern",
    "pl.free": "Kostenlos lesbar — melde dich an, um deinen Fortschritt zu speichern.",
    "pl.back": "Zum Lehrplan", "pl.cta_title": "Bereit, es anzuwenden?",
    "pl.cta_body": "Erstelle ein kostenloses Konto, speichere deinen Fortschritt und erhalte am Ende dein Abschlusszertifikat.",
    "pl.cta_btn": "Kostenlos starten",
    "footer.explore": "Entdecken", "footer.curriculum": "Lehrplan",
    "test.tools": "Test-Tools", "test.hint": "Nur zum Testen. Aktualisiert nur den Lektions-Fortschritt — die Zertifikat-Zahlung bleibt echt.",
    "test.code_placeholder": "Geheimer Test-Code",
    "test.complete_all": "Alle Lektionen als abgeschlossen markieren",
    "test.reset": "Fortschritt zurücksetzen",
    "test.done": "Alle Lektionen wurden als abgeschlossen markiert.",
    "test.reset_done": "Fortschritt zurückgesetzt.",
    "test.wrong_code": "Ungültiger Test-Code.",
  },
  ro: {
    "nav.course": "Curs", "nav.dashboard": "Panou", "nav.search": "Căutare",
    "nav.bookmarks": "Salvate", "nav.profile": "Profil", "nav.login": "Autentificare",
    "nav.logout": "Ieșire", "nav.start": "Începe gratuit",
    "hero.title1": "Înțelege AI.", "hero.title2": "Stăpânește AI.", "hero.title3": "Folosește AI.",
    "hero.sub": "Academia premium care te duce de la fundamente la utilizarea profesională a AI — pentru muncă, business și creativitate.",
    "hero.cta": "Începe gratuit", "hero.cta2": "Descoperă cursul",
    "landing.learn.title": "Ce înveți",
    "landing.learn.sub": "Un drum structurat de la primul prompt la fluxuri profesionale.",
    "landing.path.title": "Drumul tău de învățare",
    "landing.categories.title": "12 module, ~75 de lecții",
    "landing.why.title": "De ce contează AI acum",
    "landing.why.body": "AI nu mai e un viitor îndepărtat — schimbă azi felul în care muncim, scriem, cercetăm și decidem. Cine o stăpânește câștigă timp și claritate.",
    "landing.apps.title": "Aplicații practice",
    "landing.progress.title": "Progresul tău, salvat",
    "landing.progress.body": "Fiecare lecție finalizată este salvată. Continui exact de unde ai rămas — pe orice dispozitiv.",
    "landing.benefits.title": "Ce te așteaptă",
    "landing.faq.title": "Întrebări frecvente",
    "landing.finalcta.title": "Începe azi drumul tău cu AI",
    "landing.finalcta.sub": "Gratuit. Fără risc. În trei limbi.",
    "benefit.1t": "Competență reală", "benefit.1b": "Fără teorie inutilă — fiecare lecție e imediat aplicabilă.",
    "benefit.2t": "Trilingv", "benefit.2b": "Complet în germană, română și engleză.",
    "benefit.3t": "În ritmul tău", "benefit.3b": "Progres salvat, citibil offline, oricând mai departe.",
    "benefit.4t": "Făcut pentru profesioniști", "benefit.4b": "Editorial, clar și respectuos — fără kitsch de gamification.",
    "auth.login.title": "Bine ai revenit", "auth.register.title": "Creează cont",
    "auth.email": "E-mail", "auth.password": "Parolă", "auth.name": "Nume",
    "auth.login.btn": "Autentificare", "auth.register.btn": "Înregistrare gratuită",
    "auth.google": "Continuă cu Google", "auth.or": "sau",
    "auth.forgot": "Ai uitat parola?",
    "auth.noaccount": "Nu ai cont?", "auth.hasaccount": "Ai deja cont?",
    "auth.toRegister": "Înregistrează-te", "auth.toLogin": "Autentifică-te",
    "forgot.title": "Resetare parolă", "forgot.sub": "Îți trimitem un link pe e-mail.",
    "forgot.btn": "Trimite link", "forgot.sent": "Dacă e-mailul există, a fost trimis un link.",
    "reset.title": "Parolă nouă", "reset.btn": "Salvează parola", "reset.done": "Parolă schimbată. Te poți autentifica acum.",
    "onboard.skip": "Sari peste", "onboard.next": "Continuă", "onboard.start": "Să începem",
    "onboard.1t": "Bine ai venit la AI Lernwerk", "onboard.1b": "O academie calmă și focusată pentru competență AI reală.",
    "onboard.2t": "Învață structurat", "onboard.2b": "12 module te duc pas cu pas de la începător la power-user.",
    "onboard.3t": "Imediat aplicabil", "onboard.3b": "Prompturi copiabile, exemple reale și exerciții în fiecare lecție.",
    "onboard.4t": "Progresul tău contează", "onboard.4b": "Totul e salvat. Continui de unde ai rămas.",
    "dash.welcome": "Bine ai revenit", "dash.progress": "Progres total",
    "dash.continue": "Continuă", "dash.current": "Modulul curent", "dash.next": "Lecția recomandată",
    "dash.modules": "Toate modulele", "dash.daily": "Lecția zilei", "dash.lessons": "lecții", "dash.done": "finalizate",
    "dash.start": "Începe primul curs", "dash.nolast": "Începe cu prima lecție.",
    "course.title": "Cursul", "course.sub": "12 module · ~75 de lecții",
    "lesson.complete": "Marchează ca finalizat", "lesson.completed": "Finalizat",
    "lesson.prev": "Înapoi", "lesson.next": "Următoarea", "lesson.examples": "Exemple",
    "lesson.exercise": "Exercițiu", "lesson.mistakes": "Greșeli frecvente", "lesson.takeaway": "Idee-cheie",
    "lesson.copy": "Copiază promptul", "lesson.copied": "Copiat!", "lesson.bookmark": "Salvează",
    "lesson.bookmarked": "Salvat", "lesson.generating": "Se generează conținutul…",
    "search.title": "Căutare", "search.placeholder": "Caută lecții și subiecte…", "search.none": "Niciun rezultat.",
    "bookmarks.title": "Lecții salvate", "bookmarks.none": "Nimic salvat încă.",
    "profile.title": "Profilul tău", "profile.account": "Cont", "profile.language": "Limbă",
    "profile.security": "Securitate", "profile.changepw": "Schimbă parola",
    "profile.current": "Parola actuală", "profile.new": "Parolă nouă", "profile.save": "Salvează",
    "profile.danger": "Șterge contul", "profile.deletebtn": "Șterge definitiv contul",
    "profile.deleteconfirm": "Sigur ștergi contul? Va fi eliminat definitiv în 30 de zile (soft-delete).",
    "profile.saved": "Salvat.", "profile.stats": "Statistica ta",
    "common.loading": "Se încarcă…", "common.cancel": "Anulează", "common.of": "din",
    "footer.legal": "Legal", "footer.imprint": "Impressum", "footer.privacy": "Confidențialitate",
    "footer.terms": "Termeni", "footer.rights": "Toate drepturile rezervate.",
    "cookie.text": "Folosim cookie-uri pentru autentificare și (ulterior) analiză. Detalii în Confidențialitate.",
    "cookie.accept": "Accept", "cookie.decline": "Doar necesare",
    "nav.notes": "Notițe",
    "notes.heading": "Nota ta", "notes.placeholder": "Notiță pentru această lecție…",
    "notes.save": "Salvează nota", "notes.saved": "Notă salvată",
    "notes.title": "Notițele tale", "notes.none": "Încă nicio notiță.",
    "cert.title": "Certificat", "dash.certificate": "Vezi certificatul",
    "cert.locked": "Finalizează toate lecțiile ca să deblochezi certificatul.",
    "cert.remaining": "rămase", "cert.download": "Descarcă certificatul",
    "cert.awarded": "acordat lui", "cert.subtitle": "a absolvit cu succes academia AI Lernwerk",
    "cert.congrats": "Felicitări!", "cert.line": "pentru finalizarea cu succes a 12 module și 75 de lecții",
    "cert.download_pdf": "Descarcă în PDF",
    "cert.finished_title": "Program finalizat",
    "cert.finished_sub": "Ai finalizat toate cele 12 module și 75 de lecții.",
    "cert.free_note": "Întregul curs este și rămâne 100% gratuit. Certificatul este opțional.",
    "cert.buy_line": "Certificatul digital confirmă că ai finalizat programul „AI Lernwerk – AI From Zero to Pro”. Plată unică, fără abonament.",
    "cert.buy_btn": "Obține certificatul – 10 €",
    "cert.buying": "Redirecționare către Stripe…",
    "cert.verifying": "Se verifică plata…",
    "cert.paid_ok": "Plată confirmată – certificatul tău este deblocat.",
    "cert.canceled": "Plată anulată. Progresul tău rămâne salvat – poți încerca din nou.",
    "cert.not_accredited": "Confirmă finalizarea programului. Nu este o calificare de stat sau acreditată.",
    "cert.name_label": "Numele complet care va apărea pe certificat",
    "cert.name_ph": "ex. Ion Popescu",
    "cert.name_required": "Te rugăm să introduci numele complet.",
    "pwa.install": "Instalează PWA",
    "pwa.howto": "Cum instalezi aplicația: în browser deschide meniul (sau „Distribuie” pe iPhone) și alege „Adaugă pe ecranul principal”.",
    "pwa.howto_ios": "Pe iPhone/iPad: în Safari apasă „Distribuie” (Share) și apoi „Adaugă pe ecranul principal”.",
    "pwa.howto_android": "Cum instalezi aplicația: deschide meniul Chrome (trei puncte ⋮ dreapta sus) și apasă „Instalează aplicația” sau „Adaugă pe ecranul principal”.",
    "pwa.close": "Am înțeles",
    "ad.label": "Publicitate",
    "nav.admin": "Admin",
    "admin.eyebrow": "Doar pentru admin", "admin.title": "Panou de control",
    "admin.error": "Datele nu au putut fi încărcate.",
    "admin.users": "Utilizatori", "admin.revenue": "Venit certificate", "admin.certificates": "certificate vândute",
    "admin.pwa": "Instalări PWA", "admin.pwa_sub": "adăugate pe dispozitive",
    "admin.completed": "Curs finalizat", "admin.in_progress": "în curs",
    "admin.traffic": "Trafic (30 zile)", "admin.visits": "Vizite", "admin.registrations": "Înregistrări",
    "admin.traffic_note": "Vizitele se numără o dată per sesiune de browser. Pentru trafic brut vezi PostHog.",
    "admin.modules": "Progres pe module", "admin.started": "începute", "admin.done": "finalizate",
    "admin.traffic_sources": "Surse de trafic", "admin.total_visitors": "Total vizitatori",
    "admin.registered_users": "Utilizatori înregistrați", "admin.source": "Sursă", "admin.campaign": "Campanie",
    "admin.unknown_existing": "Necunoscut / Utilizator existent",
    "curr.eyebrow": "Programă", "curr.title": "Programa completă de AI",
    "curr.sub": "12 module, 75 de lecții — pot fi citite gratuit. De la fundamente la power-user.",
    "curr.read": "Citește lecția", "curr.cta": "Înregistrează-te gratuit și salvează progresul",
    "pl.free": "Poate fi citită gratuit — înregistrează-te pentru a-ți salva progresul.",
    "pl.back": "La programă", "pl.cta_title": "Gata să aplici?",
    "pl.cta_body": "Creează un cont gratuit, salvează-ți progresul și primești certificatul la final.",
    "pl.cta_btn": "Începe gratuit",
    "footer.explore": "Explorează", "footer.curriculum": "Programă",
    "test.tools": "Instrumente de test", "test.hint": "Doar pentru testare. Actualizează doar progresul lecțiilor — plata certificatului rămâne reală.",
    "test.code_placeholder": "Cod secret de test",
    "test.complete_all": "Marchează toate lecțiile ca finalizate",
    "test.reset": "Resetează progresul",
    "test.done": "Toate lecțiile au fost marcate ca finalizate.",
    "test.reset_done": "Progresul a fost resetat.",
    "test.wrong_code": "Cod de test incorect.",
  },
  en: {
    "nav.course": "Course", "nav.dashboard": "Dashboard", "nav.search": "Search",
    "nav.bookmarks": "Saved", "nav.profile": "Profile", "nav.login": "Log in",
    "nav.logout": "Log out", "nav.start": "Start free",
    "hero.title1": "Understand AI.", "hero.title2": "Master AI.", "hero.title3": "Use AI.",
    "hero.sub": "The premium academy that takes you from the fundamentals to professional AI use — for work, business and creativity.",
    "hero.cta": "Start free", "hero.cta2": "Explore the course",
    "landing.learn.title": "What you'll learn",
    "landing.learn.sub": "A structured path from your first prompt to professional workflows.",
    "landing.path.title": "Your learning path",
    "landing.categories.title": "12 modules, ~75 lessons",
    "landing.why.title": "Why AI matters now",
    "landing.why.body": "AI is no longer a distant future — it already changes how we work, write, research and decide. Those who master it gain time and clarity.",
    "landing.apps.title": "Practical applications",
    "landing.progress.title": "Your progress, saved",
    "landing.progress.body": "Every completed lesson is saved. You continue exactly where you left off — on any device.",
    "landing.benefits.title": "What awaits you",
    "landing.faq.title": "Frequently asked",
    "landing.finalcta.title": "Begin your AI journey today",
    "landing.finalcta.sub": "Free. No risk. In three languages.",
    "benefit.1t": "Real competence", "benefit.1b": "No theory without use — every lesson is immediately applicable.",
    "benefit.2t": "Trilingual", "benefit.2b": "Fully in German, Romanian and English.",
    "benefit.3t": "At your pace", "benefit.3b": "Progress saved, readable offline, continue anytime.",
    "benefit.4t": "Built for professionals", "benefit.4b": "Editorial, clear and respectful — no gamification kitsch.",
    "auth.login.title": "Welcome back", "auth.register.title": "Create account",
    "auth.email": "Email", "auth.password": "Password", "auth.name": "Name",
    "auth.login.btn": "Log in", "auth.register.btn": "Register free",
    "auth.google": "Continue with Google", "auth.or": "or",
    "auth.forgot": "Forgot password?",
    "auth.noaccount": "No account yet?", "auth.hasaccount": "Already registered?",
    "auth.toRegister": "Register now", "auth.toLogin": "Log in",
    "forgot.title": "Reset password", "forgot.sub": "We'll email you a link.",
    "forgot.btn": "Send link", "forgot.sent": "If the email exists, a link has been sent.",
    "reset.title": "New password", "reset.btn": "Save password", "reset.done": "Password changed. You can log in now.",
    "onboard.skip": "Skip", "onboard.next": "Next", "onboard.start": "Let's go",
    "onboard.1t": "Welcome to AI Lernwerk", "onboard.1b": "A calm, focused academy for real AI competence.",
    "onboard.2t": "Learn structured", "onboard.2b": "12 modules take you step by step from beginner to power user.",
    "onboard.3t": "Immediately applicable", "onboard.3b": "Copyable prompts, real examples and exercises in every lesson.",
    "onboard.4t": "Your progress counts", "onboard.4b": "Everything is saved. Continue where you left off.",
    "dash.welcome": "Welcome back", "dash.progress": "Overall progress",
    "dash.continue": "Continue learning", "dash.current": "Current module", "dash.next": "Recommended next lesson",
    "dash.modules": "All modules", "dash.daily": "Lesson of the day", "dash.lessons": "lessons", "dash.done": "completed",
    "dash.start": "Start your first course", "dash.nolast": "Begin with your first lesson.",
    "course.title": "The Course", "course.sub": "12 modules · ~75 lessons",
    "lesson.complete": "Mark as complete", "lesson.completed": "Completed",
    "lesson.prev": "Previous", "lesson.next": "Next", "lesson.examples": "Examples",
    "lesson.exercise": "Exercise", "lesson.mistakes": "Common mistakes", "lesson.takeaway": "Key takeaway",
    "lesson.copy": "Copy prompt", "lesson.copied": "Copied!", "lesson.bookmark": "Save",
    "lesson.bookmarked": "Saved", "lesson.generating": "Content is being generated…",
    "search.title": "Search", "search.placeholder": "Search lessons & topics…", "search.none": "No results.",
    "bookmarks.title": "Saved lessons", "bookmarks.none": "Nothing saved yet.",
    "profile.title": "Your profile", "profile.account": "Account", "profile.language": "Language",
    "profile.security": "Security", "profile.changepw": "Change password",
    "profile.current": "Current password", "profile.new": "New password", "profile.save": "Save",
    "profile.danger": "Delete account", "profile.deletebtn": "Delete account permanently",
    "profile.deleteconfirm": "Really delete your account? It will be permanently removed in 30 days (soft-delete).",
    "profile.saved": "Saved.", "profile.stats": "Your stats",
    "common.loading": "Loading…", "common.cancel": "Cancel", "common.of": "of",
    "footer.legal": "Legal", "footer.imprint": "Imprint", "footer.privacy": "Privacy",
    "footer.terms": "Terms", "footer.rights": "All rights reserved.",
    "cookie.text": "We use cookies for login and (later) analytics. Details in Privacy.",
    "cookie.accept": "Accept", "cookie.decline": "Necessary only",
    "nav.notes": "Notes",
    "notes.heading": "Your note", "notes.placeholder": "Note for this lesson…",
    "notes.save": "Save note", "notes.saved": "Note saved",
    "notes.title": "Your notes", "notes.none": "No notes yet.",
    "cert.title": "Certificate", "dash.certificate": "View certificate",
    "cert.locked": "Complete all lessons to unlock your certificate.",
    "cert.remaining": "remaining", "cert.download": "Download certificate",
    "cert.awarded": "awarded to", "cert.subtitle": "has successfully completed the AI Lernwerk academy",
    "cert.congrats": "Congratulations!", "cert.line": "for successfully completing 12 modules and 75 lessons",
    "cert.download_pdf": "Download as PDF",
    "cert.finished_title": "Programme completed",
    "cert.finished_sub": "You have completed all 12 modules and 75 lessons.",
    "cert.free_note": "The entire course is and remains 100% free. The certificate is optional.",
    "cert.buy_line": "The digital certificate confirms you completed the „AI Lernwerk – AI From Zero to Pro” programme. One-time payment, no subscription.",
    "cert.buy_btn": "Get the certificate – €10",
    "cert.buying": "Redirecting to Stripe…",
    "cert.verifying": "Verifying payment…",
    "cert.paid_ok": "Payment confirmed – your certificate is unlocked.",
    "cert.canceled": "Payment canceled. Your progress is saved – you can try again.",
    "cert.not_accredited": "Confirms completion of the programme. Not a state or accredited qualification.",
    "cert.name_label": "Full name as it should appear on the certificate",
    "cert.name_ph": "e.g. John Smith",
    "cert.name_required": "Please enter your full name.",
    "pwa.install": "Install PWA",
    "pwa.howto": "To install the app: open your browser menu (or “Share” on iPhone) and choose “Add to Home Screen”.",
    "pwa.howto_ios": "On iPhone/iPad: in Safari tap “Share” and then “Add to Home Screen”.",
    "pwa.howto_android": "To install the app: open the Chrome menu (three dots ⋮ top right) and tap “Install app” or “Add to Home screen”.",
    "pwa.close": "Got it",
    "ad.label": "Advertisement",
    "nav.admin": "Admin",
    "admin.eyebrow": "Admin only", "admin.title": "Overview",
    "admin.error": "Could not load data.",
    "admin.users": "Users", "admin.revenue": "Certificate revenue", "admin.certificates": "certificates sold",
    "admin.pwa": "PWA installs", "admin.pwa_sub": "added to devices",
    "admin.completed": "Course completed", "admin.in_progress": "in progress",
    "admin.traffic": "Traffic (30 days)", "admin.visits": "Visits", "admin.registrations": "Registrations",
    "admin.traffic_note": "Visits are counted once per browser session. For raw traffic see PostHog.",
    "admin.modules": "Progress per module", "admin.started": "started", "admin.done": "completed",
    "admin.traffic_sources": "Traffic Sources", "admin.total_visitors": "Total visitors",
    "admin.registered_users": "Registered users", "admin.source": "Source", "admin.campaign": "Campaign",
    "admin.unknown_existing": "Unknown / Existing user",
    "curr.eyebrow": "Curriculum", "curr.title": "The complete AI curriculum",
    "curr.sub": "12 modules, 75 lessons — free to read. From fundamentals to power user.",
    "curr.read": "Read lesson", "curr.cta": "Sign up free & save your progress",
    "pl.free": "Free to read — sign up to save your progress.",
    "pl.back": "To curriculum", "pl.cta_title": "Ready to apply it?",
    "pl.cta_body": "Create a free account, save your progress and get your completion certificate at the end.",
    "pl.cta_btn": "Start free",
    "footer.explore": "Explore", "footer.curriculum": "Curriculum",
    "test.tools": "Test tools", "test.hint": "For testing only. Updates lesson progress only — the certificate payment stays real.",
    "test.code_placeholder": "Secret test code",
    "test.complete_all": "Mark all lessons as completed",
    "test.reset": "Reset progress",
    "test.done": "All lessons marked as completed.",
    "test.reset_done": "Progress reset.",
    "test.wrong_code": "Invalid test code.",
  },
};

export const LANGS = [
  { code: "de", label: "DE" },
  { code: "ro", label: "RO" },
  { code: "en", label: "EN" },
];

const I18nContext = createContext(null);

function detectInitial() {
  const saved = localStorage.getItem("lang");
  if (saved && STR[saved]) return saved;
  return "de"; // first visit -> German
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);
  const setLang = useCallback((l) => {
    if (!STR[l]) return;
    localStorage.setItem("lang", l);
    setLangState(l);
  }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((key) => (STR[lang] && STR[lang][key]) || STR.en[key] || key, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
